import { useEffect, useContext, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import UserContext from "../UserContext";
import { LoadingOutlined } from "@ant-design/icons";
import SEO from "../Components/SEO";

// import EditProfile from "../Components/EditProfile";
function Verify() {
  const { validateOTP, mode } = useContext(UserContext);

  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  // setting the theme
  const [dark, setDark] = useState(false);
  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  let query = location.search.split("?")[1].split("&");
  let email = query[0].split("=")[1];
  let OTP_code = query[1].split("=")[1];

  const validateAccount = async () => {
    setLoading(true);
    try {
      let response = (await validateOTP({ email, OTP_code })) || {};
      let { message, success, error } = response;

      if (success) {
        window.Toast.fire({
          icon: "success",
          title: message || "Worked as expected",
        });

        history.push("/login");
      } else {
        window.displayToastError(error);
      }
    } catch (e) {
      setLoading(false);
    }
  };
  return (
    <>
      <SEO title="Verify Your Account"></SEO>
      <div
        className={
          (dark &&
            "darkmode sm:px-5 lg:px-48 h-96 flex justify-center items-center") +
          " sm:px-5 lg:px-48 h-96 flex justify-center items-center"
        }
        id="posts__container"
      >
        <div>
          {loading ? (
            <button
              type="submit"
              className="p-3 px-12 rounded-md bg-fire w-100 text-white opacity-50 gap-1 flex items-center justify-center"
              style={{ fontSize: "13px" }}
            >
              {" "}
              <LoadingOutlined /> <span> Verifying ...</span>
            </button>
          ) : (
            <button
              type="submit"
              className="p-3 px-12 rounded-md bg-fire w-100 text-white"
              style={{ fontSize: "13px" }}
              onClick={() => {
                return validateAccount();
              }}
            >
              Click to verify
            </button>
          )}
        </div>
      </div>
    </>
  );
}

export default Verify;
